import React, { useState, useEffect, useLayoutEffect, useCallback, forwardRef, useImperativeHandle, useRef } from "react";
import { useParams } from "react-router-dom";

import ReactEcharts from "echarts-for-react";
import moment from "moment";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

import $ from "jquery";

import axios from "@app/lib/axios";
import * as Constant from "@app/Constant.js";
import * as util from "@app/lib/utility";

import "./style.css";

const pageClassMaxCount = 7;
const maxReportSummaryText = 250;
const marginBase = 3;
const marginMin = 2;
const graphHeightMin = 150;
const graphHeightBarBase = 18;
const graphHeightBarMin = 16;
const graphHeightBarMax = 30;
const graphHeightXAxis = 40;
const gradeBaseLineXAxis = 16;
const tableTRLineHeightBase = 16;
const tableTRLineHeightMin = 12;

const JelliingReportTitle = ({}) => {
    return (
        <div id="report-header-title" className="row">
            <div className="col text-center title">
                <div>Jelliing Monthly Study Report</div>
            </div>
        </div>
    );
};
const JelliingReportInfo = ({ nurseryUniqInfo, selectedMonth, margin }) => {
    return (
        <div id="report-header-info" className={`row mt-${margin}`}>
            <div className="col h6 d-flex justify-content-end">
                <table>
                    <tbody>
                        <tr className="">
                            <td>원 명 :</td>
                            <td className="report-info nursery-name text-primary text-nowrap">{nurseryUniqInfo ? nurseryUniqInfo.name : "-"}</td>
                        </tr>
                        <tr>
                            <td className="">기 간 :</td>
                            <td className="report-info report-month text-primary">{selectedMonth ? `${selectedMonth.year}년 ${selectedMonth.month}월` : "-"}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};
const JelliingReportSummary = ({ classSummary, homeSummary, margin }) => {
    const title = classSummary && homeSummary ? `리포트 요약` : classSummary ? "클래스 리포트 요약" : "홈스쿨링 리포트 요약";
    const divId = classSummary && homeSummary ? `report-summary-div` : classSummary ? "report-summary-div-class" : "report-summary-div-home";
    return (
        <div id="report-summary" className={`row mt-${margin}`}>
            <div className="col report-sub">
                <div className="row">
                    <div className="col report-sub-title-text">
                        <i className="fas fa-square mr-1"></i>
                        {title}
                    </div>
                </div>
                <div className="row">
                    <div id={divId} className="col report-summary-text">
                        {classSummary && (
                            <>
                                클래스 학습량은 주 <span className="text-primary">{classSummary.avgWeek}</span>회로 <span className="text-primary">{classSummary.textGrade}</span> 학습량을 <span className="text-primary">{classSummary.textGradeDesc}</span> 있습니다.
                                <br />- 클래스 학습 :
                                {classSummary.gradeClass.length > 0 ? (
                                    <span className="report-summay-top text-primary ml-1">
                                        <u>{classSummary.gradeClass.map((c) => `${c.classes.join(",")} ${c.name}`).join(" / ")}</u>
                                    </span>
                                ) : (
                                    "-"
                                )}
                            </>
                        )}
                        {classSummary && homeSummary && <br />}
                        {homeSummary && (
                            <>
                                홈스쿨링은 앱(APP) 가입 인원 <span className="text-primary">{homeSummary.total}</span>명 대비 <span className="text-primary">{homeSummary.usePercent}</span>%의 사용율을 보여주고 있습니다.
                                <br />- 홈스쿨링 최다 학습 원아 Top 5 :
                                {homeSummary.top.length > 0 ? (
                                    <span className="report-summay-top text-primary ml-1">
                                        <u>{homeSummary.top.map((t) => `${t.name} ${t.childs.join(",")}`).join(", ")}</u>
                                    </span>
                                ) : (
                                    "-"
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
const JelliingReportClass = ({ classList, classUseGrade, margin, graphHeight, graphHeightBar, tableTRLineHeight }) => {
    useEffect(() => {
        return () => {};
    }, [classList]);
    let maxValue = 50;
    if (classList && classList.length > 0) {
        classList.forEach((c) => {
            if (c.stat.class.total > maxValue) {
                maxValue = c.stat.class.total;
            }
        });
    }
    maxValue = maxValue > 900 ? Math.ceil(maxValue / 100) * 100 + 100 : (maxValue > 90 ? Math.ceil(maxValue / 10) * 10 + 20 : Math.ceil(maxValue / 10) * 10 + 5);
    const optionClass = {
        tooltip: {
            trigger: "axis",
            axisPointer: {
                type: "shadow",
            },
        },
        legend: {
            show: false,
        },
        grid: {
            top: "5px",
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true,
        },
        xAxis: {
            type: "value",
            interval: 40,
            max: maxValue,
            axisLabel: {
                color: "#000",
            },
        },
        yAxis: {
            type: "category",
            inverse: true,
            axisLabel: {
                color: "#000",
            },
            data: classList ? classList.map((c) => c.name) : [],
        },
        series: [
            {
                name: "젤링학습",
                type: "bar",
                stack: "base",
                label: {
                    show: true,
                    position: "insideRight",
                    color: "#fff",
                    formatter: (params) => {
                        if (params.value > 0) {
                            if ((params.value / maxValue) * 100 < 20) {
                                return params.value;
                            }
                            return "젤링학습 " + params.value;
                        } else {
                            return "";
                        }
                    },
                },
                data: classList
                    ? classList.map((c) => {
                          return { value: c.stat.class.playCountClassSumTotal, itemStyle: { color: c.stat.class.grade.colorClass } };
                      })
                    : [],
                markLine: {
                    data: [
                        {
                            name: "min",
                            xAxis: gradeBaseLineXAxis,
                            label: { position: "end", distance: 4, borderType: "dotted", borderWidth: 1, color: "#fff", backgroundColor: "#11f", borderRadius: 4, padding: [4, 4, 2, 4] },
                            lineStyle: { normal: { type: "dashed", color: "#11fa", width: 2 } },
                        },
                    ],
                    symbol: ["none", "none"],
                },
            },
            {
                name: "스페셜",
                type: "bar",
                stack: "base",
                label: {
                    show: true,
                    position: "insideRight",
                    color: "#222",
                    formatter: (params) => {
                        if (params.value > 0) {
                            if ((params.value / maxValue) * 100 < 15) {
                                return params.value;
                            }
                            return "스페셜 " + params.value;
                        } else {
                            return "";
                        }
                    },
                },
                data: classList
                    ? classList.map((c) => {
                          return { value: c.stat.class.playCountSpecialSumTotal, itemStyle: { color: c.stat.class.grade.colorSpecial } };
                      })
                    : [],
            },
        ],
    };
    return (
        <div id="report-class" className={`row mt-${margin}`}>
            <div className="col report-sub flyeng-class">
                <div className="row">
                    <div className="col-4 report-sub-title-text">
                        <i className="fas fa-square mr-1"></i> 클래스 학습 현황
                    </div>
                    <div className="col-8 report-sub-description-text d-flex justify-content-end">
                        젤링학습이란? 매주마다 정해진 요일에 실행하는 영어 콘텐츠
                        <br />
                        스페셜이란? 매달 제공되는 마더구스송, 액션송, 파닉스송, 마더구스 스토리, 파닉스 스토리 콘텐츠
                    </div>
                </div>
                <div className="row">
                    <div style={{display: "flex"}}>
                        <div className="report-sub-graph" style={{ height: graphHeight }}>
                            <ReactEcharts theme="macarons" style={{ width: "100%", height: "100%" }} option={optionClass} opts={{ renderer: "svg" }} />
                        </div>
                        <div className="report-sub-graph-class-explain">
                            <table>
                                <tbody>
                                    {classUseGrade.map((g, index) => {
                                        return (
                                            <tr key={"class-grade-" + index}>
                                                <td>
                                                    {g.name}({g.min}
                                                    {g.max ? `-${g.max}` : "이상"})
                                                </td>
                                                <td>
                                                    <div style={{ backgroundColor: g.colorClass }}></div>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                    <tr>
                                        <td colSpan={2}>※ 기본 학습 횟수 기준 : {gradeBaseLineXAxis}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className="row mt-0">
                    <div className="col report-sub-table">
                        <table>
                            <thead>
                                <tr style={{ lineHeight: `${tableTRLineHeight}px` }}>
                                    <th className="class-name">구분</th>
                                    {classList && classList.length > 0 ? (
                                        classList[0].stat.class.weekly.map((w, index) => {
                                            return (
                                                <th className="class-week" key={"class-week-" + index}>
                                                    {index + 1}주
                                                    <br />({w.first}~{w.last})
                                                </th>
                                            );
                                        })
                                    ) : (
                                        <>
                                            <th className="class-week">1주</th>
                                            <th className="class-week">2주</th>
                                            <th className="class-week">3주</th>
                                            <th className="class-week">4주</th>
                                        </>
                                    )}
                                    <th className="class-comment">합계</th>
                                    <th className="class-comment">주 평균</th>
                                    <th className="class-comment">평가</th>
                                </tr>
                            </thead>
                            <tbody>
                                {classList && classList.length > 0 ? (
                                    classList.map((c, index) => {
                                        return (
                                            <tr key={"class-week-tr-" + index} style={{ lineHeight: `${tableTRLineHeight}px` }}>
                                                <td>{c.name}</td>
                                                {c.stat.class.weekly.map((w, index2) => {
                                                    return <td key={"class-week-td-" + index + "-" + index2}>{w.playCountClassSum + w.playCountSpecialSum}</td>;
                                                })}
                                                <td>{c.stat.class.total}</td>
                                                <td>{c.stat.class.avgWeek}</td>
                                                <td style={{ color: c.stat.class.grade.colorClass }}>{c.stat.class.grade.name}</td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <></>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};
const JelliingReportPageHome = ({ periodInfo, homeCategorizedCategory, graphHeight, classList, tableTRLineHeight }) => {
    let maxValue = 50;
    if (classList && classList.length > 0) {
        classList.forEach((c) => {
            if (c.stat.home.total > maxValue) {
                maxValue = c.stat.home.total;
            }
        });
    }
    maxValue = maxValue > 900 ? Math.ceil(maxValue / 100) * 100 + 100 : (maxValue > 90 ? Math.ceil(maxValue / 10) * 10 + 20 : Math.ceil(maxValue / 10) * 10 + 5);
    const optionHome = {
        tooltip: {
            trigger: "axis",
            axisPointer: {
                type: "shadow",
            },
        },
        legend: {
            show: false,
        },
        grid: {
            top: "5px",
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true,
        },
        xAxis: {
            type: "value",
            interval: maxValue / 5,
            max: maxValue,
            axisLabel: {
                color: "#000",
            },
        },
        yAxis: {
            type: "category",
            inverse: true,
            axisLabel: {
                color: "#000",
            },
            data: classList ? classList.map((c) => c.name) : [],
        },
        itemStyle: {
            color: ["#728eec"],
        },
        series: [
            {
                name: "콘텐츠 실행 수",
                type: "bar",
                stack: "base",
                label: {
                    show: true,
                    position: "right",
                    formatter: (params) => {
                        return params.value;
                    },
                },
                data: classList ? classList.map((c) => c.stat.home.total) : [],
            },
        ],
    };

    return (
        <div id="report-home" className={`row mt-2`}>
            <div className="col report-sub stat-home">
                <div className="row">
                    <div className="col report-sub-title-text">
                        <i className="fas fa-square mr-1"></i> 홈스쿨링 학습 현황
                    </div>
                </div>
                <div className="row">
                    <div className="col report-sub-graph" style={{ height: graphHeight }}>
                        <ReactEcharts theme="macarons" style={{ width: "100%", height: "100%" }} option={optionHome} opts={{ renderer: "svg" }} />
                    </div>
                </div>
                <div className="row mt-0">
                    <div className="col report-sub-table">
                        <table>
                            <thead>
                                <tr style={{ lineHeight: `${tableTRLineHeight}px` }}>
                                    <th className="class-name">구분</th>
                                    {
                                        homeCategorizedCategory && homeCategorizedCategory.map((cat) => {
                                            return (
                                                <th className="home-category">
                                                    {cat.categories.length > 1
                                                        ? (
                                                            <>
                                                                <span>{cat.name}</span>
                                                                <br />
                                                                <span className="home-category-names">({cat.categoryNames})</span>
                                                            </>
                                                        ) : (
                                                            <span>{cat.name}</span>
                                                        )
                                                    }
                                                </th>
                                            )
                                        })
                                    }
                                    <th className="home-comment home-sum">합계</th>
                                    <th className="home-comment home-user">APP<br/>가입인원</th>
                                    <th className="home-comment home-user">콘텐츠<br/>이용인원</th>
                                </tr>
                            </thead>
                            <tbody>
                                {classList && classList.length > 0 ? (
                                    classList.map((c, index) => {
                                        return (
                                            <tr key={"home-class-tr-" + index} style={{ lineHeight: `${tableTRLineHeight}px` }}>
                                                <td>{c.name}</td>
                                                {c.stat.home.categories.map((cat, index2) => {
                                                    return <td key={"home-class-td-" + index + "-" + index2}>{cat.playCountSum}</td>;
                                                })}
                                                <td>{c.stat.home.total}</td>
                                                <td>{c.childJoin}</td>
                                                <td>{c.childUse}</td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <></>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="row">
                    <div className="col report-sub-table report-sub-description-text" style={{paddingTop: "0px"}}>
                        &lt;젤링 홈스쿨링 학습 데이터 통계 기간: {periodInfo.startDate} ~ {periodInfo.endDate}&gt;
                    </div>
                </div>
            </div>
        </div>
    );
};
const ReportPage = forwardRef(({ selectedMonth, periodInfo, homeCategorizedCategory, nurseryUniqInfo, classSummary, homeSummary, classList, classUseGrade }, ref) => {
    const [shouldPageBreak, setShouldPageBreak] = useState(false);
    useEffect(() => {
        if (classList) {
            setShouldPageBreak(classList.length > pageClassMaxCount);
        }
        return () => {};
    }, [classList]);
    const pxTomm = (px) => {
        return Math.floor(px * 0.264583);
    };
    let margin = marginBase;
    let graphHeight = graphHeightMin;
    let graphHeightBar = graphHeightBarBase;
    let tableTRLineHeight = tableTRLineHeightBase;
    if (classList && classList.length > 0) {
        if (classList.length > 17) {
            margin = marginMin;
            graphHeightBar = graphHeightBarMin;
            tableTRLineHeight = tableTRLineHeightMin;
        } else if (classList.length >= 6 && classList.length <= pageClassMaxCount) {
            graphHeightBar = graphHeightBarBase;
            if (classList.length > 6) {
                tableTRLineHeight = tableTRLineHeightMin;
            }
        } else {
            graphHeightBar = graphHeightBarMax - (classList.length - 6) < graphHeightBarMin ? graphHeightBarMin : graphHeightBarMax - (classList.length - 6);
        }
        graphHeight = classList.length * graphHeightBar + graphHeightXAxis;
        if (graphHeight < graphHeightMin) {
            graphHeight = graphHeightMin;
        }
    }
    // 요약 div 클릭 핸들러 등록
    let summaryEdit = {};
    function divClicked() {
        const divId = $(this)[0].id;
        var divHtml = $(this).html();
        var editableText = $(`<textarea id='${divId}' style='margin-left: 38px; width: 100%; height: 100px' />`);
        var tempDiv = $("<div />");
        if (summaryEdit[divId]) {
            summaryEdit[divId] = { origin: divHtml, edit: false, changed: false };
        } else {
            summaryEdit[divId] = { origin: divHtml, edit: false };
        }
        divHtml = divHtml.replaceAll("<br>", "\n");
        tempDiv.html(divHtml);
        editableText.val(tempDiv.text());
        $(this).replaceWith(editableText);
        editableText.focus();
        // setup the blur event for this new textarea
        editableText.blur(editableTextBlurred);
        editableText.keyup(checkSummaryLength);
    }
    function editableTextBlurred() {
        const divId = $(this)[0].id;
        var viewableText = $(`<div id="${divId}" class="col report-summary-text" />`);
        if (summaryEdit[divId].edit == false) {
            viewableText.html(summaryEdit[divId].origin);
        } else {
            if (summaryEdit[divId].changed == false) {
                summaryEdit[divId].changed = true;
            }
            var html = $(this).val();
            html = html.replaceAll("\n", "<br>").trim();
            viewableText.html(html);
        }
        $(this).replaceWith(viewableText);
        summaryEdit[divId] = null;
        // setup the click event for this new div
        viewableText.click(divClicked);
    }
    function checkSummaryLength() {
        const divId = $(this)[0].id;
        summaryEdit[divId].edit = true;
        if ($(this).val().length > maxReportSummaryText) {
            alert(`등록 가능한 글자수는 공백을 포함하여\n최대 ${maxReportSummaryText}자입니다.`);
            $(this).val($(this).val().substring(0, 250));
        }
    }
    $(document).ready(function () {
        $(".report-summary-text").click(divClicked);
    });
    useEffect(() => {
        window.addEventListener("beforeunload", handleUnload);
        return () => {
            window.removeEventListener("beforeunload", handleUnload);
        };
    }, []);
    const handleUnload = (e) => {
        const message = "변경 사항은 저장되지 않습니다.";
        (e || window.event).returnValue = message; //Gecko + IE
        return message;
    };
    return (
        <div id="pageToPrint" className="page-root stat-report" ref={ref}>
            {!shouldPageBreak && (
                <div className="page">
                    <div className="sub-page">
                        <JelliingReportTitle margin={margin} />
                        <JelliingReportInfo nurseryUniqInfo={nurseryUniqInfo} selectedMonth={selectedMonth} margin={margin} />
                        <JelliingReportSummary classSummary={classSummary} homeSummary={homeSummary} />
                        <JelliingReportClass
                            periodInfo={periodInfo}
                            classList={classList}
                            classUseGrade={classUseGrade}
                            margin={margin}
                            graphHeight={graphHeight}
                            tableTRLineHeight={tableTRLineHeight}
                        />
                        <JelliingReportPageHome periodInfo={periodInfo} homeCategorizedCategory={homeCategorizedCategory} classList={classList} margin={margin} graphHeight={graphHeight} tableTRLineHeight={tableTRLineHeight} />
                    </div>
                </div>
            )}
            {shouldPageBreak && (
                <>
                    <div className="page">
                        <div className="sub-page">
                            <JelliingReportTitle margin={margin} />
                            <JelliingReportInfo nurseryUniqInfo={nurseryUniqInfo} selectedMonth={selectedMonth} margin={margin} />
                            <JelliingReportSummary classSummary={classSummary} margin={margin} />
                            <JelliingReportClass
                                periodInfo={periodInfo}
                                classList={classList}
                                classUseGrade={classUseGrade}
                                margin={margin}
                                graphHeight={graphHeight}
                                tableTRLineHeight={tableTRLineHeight}
                            />
                        </div>
                    </div>
                    <div className="page">
                        <div className="sub-page">
                            <JelliingReportTitle margin={margin} />
                            <JelliingReportInfo nurseryUniqInfo={nurseryUniqInfo} selectedMonth={selectedMonth} margin={margin} />
                            <JelliingReportSummary homeSummary={homeSummary} margin={margin} />
                            <JelliingReportPageHome periodInfo={periodInfo} homeCategorizedCategory={homeCategorizedCategory} classList={classList} margin={margin} graphHeight={graphHeight} tableTRLineHeight={tableTRLineHeight} />
                        </div>
                    </div>
                </>
            )}
        </div>
    );
});

export default ReportPage;
